<script lang="ts" setup>
import {computed} from "vue";

const {collectionUri} = useI18nCollection();
const page = await queryCollection(collectionUri('home')).first();
const coverImages: string[] = (page.meta?.cover_images || []).map((img: string) => img.replace('/assets', ''));

const img = useImage();
const url = useRequestURL();

const currentUrl = `${url.protocol}//${url.host}`;
const preloadImageCount = ref<number>(1);
const currentGalleryImageIndex = ref(0);

const galleryImagesList = ref((await useFetch(`/api/home-background`)).data.value || []);

const galleryImages = computed<string[]>(() => galleryImagesList.value.filter((img: string) => coverImages.includes(img)));
let interval: ReturnType<typeof setInterval>;

useSeoMeta({
    title: page.meta!.seoTitle as string,
    ogTitle: page.meta!.seoTitle as string,
    description: page.meta!.seoDescription as string,
    ogDescription: page.meta!.seoDescription as string,
    ogImage: currentUrl + img(galleryImages!.value[0] as string, {
        width: 1200,
        height: 630,
        fit: 'cover',
        format: 'jpg',
    }),
    twitterCard: 'summary_large_image',
});

function startInterval() {
    if (galleryImages.value.length < 1) return;
    if (interval) return;
    interval = setInterval(() => {
        currentGalleryImageIndex.value =
                (currentGalleryImageIndex.value + 1) % galleryImages.value.length;
        if (preloadImageCount.value < galleryImages.value.length) {
            preloadImageCount.value += 1;
        }
    }, 5000);
}

onUnmounted(() => {
    clearInterval(interval);
});
</script>

<template>
  <div>
    <NuxtLayout
      name="layout-with-background"
      :img-uri="galleryImages[currentGalleryImageIndex]"
      :fade-slow="true"
    >
      <main class="text-center">
        <HeroHome />
        <SectionServices />
        <div
                v-if="galleryImages"
                class="hidden"
                aria-hidden="true"
        >
          <template
                  v-for="(galleryImage, index) in galleryImages" :key="galleryImage">
            <media-background :expose-only="index !== 0" :img-uri="galleryImage" :lazy="false" @load="startInterval"/>
          </template>
        </div>
      </main>
    </NuxtLayout>
  </div>
</template>